(function (global) {
  'use strict';
  function searchURL(path, origin, query, type, section) {
    var term = String(query || '').trim();
    if (!term) return null;
    var url;
    try { url = new URL(path, origin); } catch (error) { return null; }
    if (url.origin !== origin) return null;
    url.search = '';
    url.hash = '';
    url.searchParams.set('q', term);
    url.searchParams.set('type', type || 'product');
    url.searchParams.set('options[prefix]', 'last');
    if (section) url.searchParams.set('section_id', section);
    return url.href;
  }
  function visibleLinks(panel) {
    return Array.from(panel.querySelectorAll('a')).filter(function (link) {
      for (var node = link; node && node !== panel; node = node.parentElement) if (node.hidden) return false;
      return !panel.hidden;
    });
  }
  function initHost(host, template, win) {
    if (host.__skSearchAssist || host.querySelector('predictive-search')) return host.__skSearchAssist;
    var doc = host.ownerDocument;
    var input = host.querySelector('input[type="search"]');
    var form = input && input.closest('form');
    if (!input || !form) return null;
    if (host.__skHomeRecent) host.__skHomeRecent.destroy();
    var panel = template.content.firstElementChild.cloneNode(true);
    var start = panel.querySelector('[data-sk-search-start]');
    var queryPanel = panel.querySelector('[data-sk-search-query]');
    var heading = panel.querySelector('[data-sk-search-heading]');
    var history = panel.querySelector('[data-sk-search-history]');
    var historyLinks = panel.querySelector('[data-sk-search-history-links]');
    var products = panel.querySelector('[data-sk-search-products]');
    var status = panel.querySelector('[data-sk-search-status]');
    var allLink = panel.querySelector('[data-sk-search-all]');
    var readingLink = panel.querySelector('[data-sk-search-reading]');
    var description = panel.querySelector('[data-sk-search-description]');
    var config = template.dataset;
    var serial = (win.__skSearchAssistSerial || 0) + 1;
    win.__skSearchAssistSerial = serial;
    panel.id = 'SkSearchAssist-' + serial;
    description.id = panel.id + '-help';
    var old = { placeholder: input.getAttribute('placeholder'), describedby: input.getAttribute('aria-describedby'), controls: input.getAttribute('aria-controls'), autocomplete: input.getAttribute('autocomplete') };
    var listeners = [], sequence = 0, debounceTimer, requestTimer, focusTimer, controller, composing = false, suppressFocus = false;
    var cache = new Map();
    host.classList.add('sk-search-assist-host');
    host.appendChild(panel);
    input.setAttribute('placeholder', config.placeholder);
    input.setAttribute('autocomplete', 'off');
    function on(node, event, fn, options) { node.addEventListener(event, fn, options); listeners.push(function () { node.removeEventListener(event, fn, options); }); }
    function cancel() {
      sequence += 1;
      win.clearTimeout(debounceTimer); win.clearTimeout(requestTimer);
      if (controller) controller.abort();
    }
    function restore(name, value) { if (value === null) input.removeAttribute(name); else input.setAttribute(name, value); }
    function hide() {
      cancel(); panel.hidden = true;
      restore('aria-describedby', old.describedby); restore('aria-controls', old.controls);
    }
    function open() {
      panel.hidden = false;
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-describedby', [old.describedby, description.id].filter(Boolean).join(' '));
    }
    function focusInput() { suppressFocus = true; input.focus({ preventScroll: true }); suppressFocus = false; }
    function eligible(term) { return !composing && host.isConnected && !panel.hidden && host.contains(doc.activeElement) && input.value.trim() === term; }
    function linksFrom(markup, selector, ids) {
      var parsed = new win.DOMParser().parseFromString(markup, 'text/html');
      var wrapper = parsed.querySelector(selector);
      if (!wrapper) throw Error('Missing search response');
      var candidates = Array.from(wrapper.querySelectorAll('a'));
      if (ids) candidates = ids.map(function (id) { return candidates.find(function (a) { return a.dataset.skRecentProduct === id; }); }).filter(Boolean);
      var seen = new Set();
      return candidates.filter(function (a) {
        var id = a.dataset.skSearchProduct || a.dataset.skRecentProduct;
        var url;
        try { url = new URL(a.getAttribute('href'), win.location.origin); } catch (error) { return false; }
        if (!/^[1-9]\d*$/.test(id || '') || seen.has(id) || url.origin !== win.location.origin || !/\/products\/[^/]+$/.test(url.pathname)) return false;
        seen.add(id); return true;
      }).slice(0, ids ? 3 : 4).map(function (a) {
        var link = a.cloneNode(true);
        link.removeAttribute('id');
        link.classList.add('sk-search-assist-product');
        return link;
      });
    }
    function place(target, links) { target.replaceChildren.apply(target, links); }
    async function request(url, term, isHistory, ids, attempt) {
      controller = new win.AbortController();
      var activeController = controller;
      requestTimer = win.setTimeout(function () { activeController.abort(); }, 6500);
      var activeTimer = requestTimer;
      try {
        var response = await win.fetch(url, { credentials: 'same-origin', signal: activeController.signal });
        if (!response.ok) throw Error('Search unavailable');
        var markup = await response.text();
        if (attempt !== sequence || !eligible(term)) return;
        var links = linksFrom(markup, isHistory ? '[data-sk-recent-search-results]' : '[data-sk-search-suggestions]', ids);
        if (isHistory) { place(historyLinks, links); history.hidden = !links.length; }
        else {
          cache.set(term, links.map(function (a) { return a.cloneNode(true); }));
          if (cache.size > 8) cache.delete(cache.keys().next().value);
          place(products, links);
          status.textContent = links.length ? config.ready : config.empty;
          status.classList.toggle('visually-hidden', links.length > 0);
        }
      } catch (error) {
        if (attempt === sequence && eligible(term) && !isHistory) { status.textContent = config.failed; status.classList.remove('visually-hidden'); }
      } finally { win.clearTimeout(activeTimer); }
    }
    function show() {
      if (suppressFocus || composing || doc.activeElement !== input) return;
      cancel();
      var attempt = sequence;
      var term = input.value.trim();
      open();
      start.hidden = Boolean(term); queryPanel.hidden = !term;
      heading.textContent = term ? config.resultsHeading : config.categoryHeading;
      if (!term) {
        history.hidden = true; historyLinks.replaceChildren();
        if (!win.SKHomeBrowse) return;
        var ids = win.SKHomeBrowse.readRecent(function () { return win.localStorage; }, Date.now());
        var recentURL = win.SKHomeBrowse.requestURL(config.searchUrl, win.location.origin, ids);
        if (recentURL) request(recentURL, term, true, ids, attempt);
        return;
      }
      allLink.setAttribute('href', searchURL(config.searchUrl, win.location.origin, term, 'product'));
      readingLink.setAttribute('href', searchURL(config.searchUrl, win.location.origin, term, 'article,page'));
      panel.querySelector('[data-sk-search-term]').textContent = '「' + term + '」';
      products.replaceChildren();
      status.classList.remove('visually-hidden');
      if (cache.has(term)) {
        var cached = cache.get(term).map(function (a) { return a.cloneNode(true); });
        place(products, cached); status.textContent = cached.length ? config.ready : config.empty; status.classList.toggle('visually-hidden', cached.length > 0); return;
      }
      status.textContent = config.loading;
      var url = searchURL(config.searchUrl, win.location.origin, term, 'product', 'sk-search-suggestions');
      if (!url) { hide(); return; }
      debounceTimer = win.setTimeout(function () { request(url, term, false, null, attempt); }, 280);
    }
    on(input, 'focus', show);
    on(input, 'click', function () { if (panel.hidden) show(); });
    on(input, 'input', function () { if (!composing) show(); });
    on(input, 'compositionstart', function () { composing = true; hide(); });
    on(input, 'compositionend', function () { composing = false; show(); });
    on(input, 'keydown', function (event) {
      if (composing || event.isComposing || event.keyCode === 229) { if (event.key === 'Enter') event.preventDefault(); return; }
      if (event.key === 'Escape') { if (!panel.hidden) { event.preventDefault(); event.stopPropagation(); hide(); } }
      else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (panel.hidden) show();
        var links = visibleLinks(panel);
        if (links.length) { event.preventDefault(); links[event.key === 'ArrowDown' ? 0 : links.length - 1].focus(); }
      }
    });
    on(form, 'submit', function (event) { if (composing || !input.value.trim()) event.preventDefault(); else hide(); });
    on(panel, 'keydown', function (event) {
      if (event.isComposing || event.keyCode === 229) return;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); hide(); focusInput(); return; }
      var links = visibleLinks(panel), index = links.indexOf(doc.activeElement);
      if (index < 0 || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'ArrowUp' && index === 0) focusInput();
      else links[event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : Math.max(0, Math.min(links.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))].focus();
    });
    on(panel.querySelector('[data-sk-search-close]'), 'click', function () { hide(); focusInput(); });
    on(host, 'focusout', function () { win.clearTimeout(focusTimer); focusTimer = win.setTimeout(function () { if (!host.contains(doc.activeElement)) hide(); }, 0); });
    on(doc, 'pointerdown', function (event) { if (!host.contains(event.target)) hide(); });
    on(win, 'pagehide', hide);
    on(win, 'pageshow', function () { composing = false; cache.clear(); hide(); });
    on(win, 'storage', function (event) { if (event.key === 'recentlyViewedProducts' || event.key === null) { hide(); if (doc.activeElement === input && !input.value.trim()) show(); } });
    host.__skSearchAssist = { show: show, hide: hide, destroy: function () {
      hide(); win.clearTimeout(focusTimer); listeners.forEach(function (remove) { remove(); }); panel.remove();
      restore('placeholder', old.placeholder); restore('autocomplete', old.autocomplete);
      host.classList.remove('sk-search-assist-host'); delete host.__skSearchAssist;
    } };
    return host.__skSearchAssist;
  }
  var api = { searchURL: searchURL, initHost: initHost, visibleLinks: visibleLinks };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  function init() {
    var template = global.document.querySelector('[data-sk-search-assist-template]');
    if (!template) return;
    global.document.querySelectorAll('#header .header-search-global').forEach(function (host) { initHost(host, template, global); });
  }
  function destroy() { global.document.querySelectorAll('.sk-search-assist-host').forEach(function (host) { if (host.__skSearchAssist) host.__skSearchAssist.destroy(); }); }
  if (!global.__skSearchAssistLifecycle) {
    global.__skSearchAssistLifecycle = true;
    global.document.addEventListener('shopify:section:load', function () { destroy(); init(); });
    global.document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.querySelector('[data-sk-search-assist-template]')) destroy();
      else event.target.querySelectorAll('.sk-search-assist-host').forEach(function (host) { if (host.__skSearchAssist) host.__skSearchAssist.destroy(); });
    });
  }
  if (global.document.readyState !== 'complete') global.document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})(typeof window === 'undefined' ? globalThis : window);
